import React from 'react'

import './Burger.css'

const Burger = ({ burgerOpen, handleBurgerCLick }) => (
  <div>
    <button
      onClick={handleBurgerCLick}
      className={
        'fmbm-burger fmbm-burger--spin' +
        (burgerOpen ? ' fmbm-burger--is-active' : '')
      }
      type="button"
    >
      <span className="fmbm-burger-box">
        <span className="fmbm-burger-inner" />
      </span>
    </button>
  </div>
)

export default Burger



// WEBPACK FOOTER //
// ./src/Components/Burger/Burger.js